// Port of api/fuel/app/classes/insights/players/groups.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'groups',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	detail: ['groups'],
	run: function(type, owner, userIndex, detail) {
		var groups = {}
		var limit = detail ? 250 : 5
		var playKeys = Object.keys(this._data.plays || {})

		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (play.pl > 2) {
				if (!groups[play.playersKey]) {
					groups[play.playersKey] = {
						count: 0,
						duration: 0,
						players: play.playersIndex,
						lastDate: 0
					}
				}

				groups[play.playersKey].count += play.c
				if (play.d > groups[play.playersKey].lastDate) groups[play.playersKey].lastDate = play.d
			}
		}

		var list = Object.keys(groups).map(function(key) { return groups[key] })
		var total = list.length
		list = list.slice().sort(function(a, b) {
			if (b.count !== a.count) return b.count - a.count
			if (b.lastDate !== a.lastDate) return b.lastDate - a.lastDate
			var aKey = (a.players || []).join('-')
			var bKey = (b.players || []).join('-')
			return String(aKey).localeCompare(String(bKey))
		})
		if (list.length > limit) list = list.slice(0, limit)

		for (var g = 0; g < list.length; g++) {
			var players = []
			for (var p = 0; p < list[g].players.length; p++) {
				var player = this._data.players[list[g].players[p]]
				players.push({
					id: parseInt(player.id, 10) || 0,
					slug: player.slug,
					name: player.primaryName,
					username: player.username
				})
			}
			list[g].players = players
		}

		return {
			groups: {
				total: total,
				groups: list
			}
		}
	}
})
